/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import 'assets/sass/style.scss';
import { connect, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import * as actions from 'redux/actions/index';
import { routes } from 'Utility/constants';

const Header = (props) => {
   let dispatch = useDispatch();
   const Signout = () => {
      dispatch(actions.logout());
   };

   const [openNav, setOpenNav] = useState(false);
   if (!props.user || (props.user && !props.user.verified) || (props.user && props.history.location.pathname.includes(routes.RESETPASSWORD))) {
      return (
         <header className="main_header">
            <nav className="theme_navigation navbar login_nav">
               <a
                  className="logo"
                  onClick={() => {
                     props.history.push(routes.HOME);
                  }}
               >
                  <img
                     src={require('assets/images/thumbnails/logo.png')}
                     alt="InHarmony Web Logo"
                     className="header__logo"
                  />
               </a>
            </nav>
         </header>
      );
   } else {
   }

   let navClassName = 'theme_navigation -closed navbar navbar-expand-lg';
   if (openNav) {
      navClassName = 'theme_navigation -closed navbar navbar-expand-lg -open';
   }
   return (
      <header className="main_header">
         <nav className={navClassName}>
            <a className="logo" href="javascript:void(0)">
               <img
                  src={require('assets/images/thumbnails/logo.png')}
                  alt="InHarmony Web Logo"
                  className="header__logo"
                  onClick={() => props.history.push(routes.HOME)}
               />
            </a>
            <span
               className="navigation-toggler"
               onClick={() => setOpenNav(!openNav)}
            >
               <span className="sr-only">Toggle navigation</span>
               <span className="icon-bar"></span>
               <span className="icon-bar"></span>
               <span className="icon-bar"></span>
            </span>

            <div className="nav_both_wrp">
               <ul className="nav navbar-nav justify-content-end">
                  <li className="nav-item">
                     <ul className="profile_dropdown avatar_dropdown">
                        <li className="dropdown">
                           <a
                              href="#"
                              className="dropdown-toggle nav-link user_menu_dropdown not_line"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              role="button"
                              aria-expanded="false"
                           >
                              <span className="avatar_circle">
                                 <img
                                    src={
                                       props.user.photo_url
                                          ? props.user.photo_url.medium
                                          : require('assets/images/thumbnails/user_placeholder.png')
                                    }
                                    alt="User"
                                 />
                              </span>
                              <span className="avatar_txt">
                                 {props.user ? props.user.first_name : null}{' '}
                                 {props.user ? props.user.last_name : null}
                              </span>
                           </a>
                           <ul className="dropdown-menu dropdown-menu-right">
                              <div className="topbdr_shape"></div>
                              <li
                                 role="presentation"
                                 className="list_item border_btm_sep"
                              >
                                 <a
                                    role="menuitem"
                                    tabindex="-1"
                                    href="javascript:void(0)"
                                    onClick={() =>
                                       props.history.push(routes.HOME)
                                    }
                                 >
                                    Welcome,{' '}
                                    <span className="nile_100">
                                       {props.user
                                          ? props.user.first_name
                                          : null}{' '}
                                       {props.user
                                          ? props.user.last_name
                                          : null}
                                    </span>
                                 </a>
                              </li>
                              <li role="presentation" className="list_item">
                                 <a
                                    role="menuitem"
                                    tabindex="-1"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                       setOpenNav(false);
                                       props.history.push(routes.PROFILE);
                                    }}
                                 >
                                    Profile Settings
                                 </a>
                              </li>
                              <li role="presentation" className="list_item">
                                 <a
                                    role="menuitem"
                                    tabindex="-1"
                                    href="javascript:void(0)"
                                    onClick={() => {
                                       setOpenNav(false);
                                       props.history.push(routes.MYPLAN);
                                    }}
                                 >
                                    Manage Subscription
                                 </a>
                              </li>
                              <li role="presentation" className="list_item">
                                 <a
                                    role="menuitem"
                                    tabindex="-1"
                                    href="javascript:void(0)"
                                    onClick={Signout}
                                 >
                                    Log Out
                                 </a>
                              </li>
                           </ul>
                        </li>
                     </ul>
                  </li>
               </ul>
            </div>
         </nav>
      </header>
   );
};

const Footer = () => {
   var d = new Date();
   let year = d.getFullYear();
   return (
      <footer className="main_footer wow fadeIn">
         <div className="link_list_group">
            <span className="ph_textcopy footer_link">
               © {year} inHarmony, Inc. All rights reserved |{' '}
               <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto:help@iaminharmony.com?subject=Support - inHarmony: Music Meditations Web App"
               >
                  Contact Support
               </a>
            </span>
         </div>
      </footer>
   );
};

class Layout extends React.Component {
   render() {
      return (
         <>
            <div className="limiter">
               <div className="container-login100">
                  <Header {...this.props} />
                  {this.props.children}
                  <Footer {...this.props} />
               </div>
            </div>
         </>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
   };
};

const RLayout = withRouter(Layout);

export default connect(mapStateToProps)(RLayout);
